import { render, staticRenderFns } from "./Javascript.vue?vue&type=template&id=7e23c4ae&scoped=true&"
import script from "./Javascript.vue?vue&type=script&lang=js&"
export * from "./Javascript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e23c4ae",
  null
  
)

export default component.exports